import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconThumbtack: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconThumbtack"><Path d="M6.5 2V6.99695C6.5 8.72086 5.81518 10.3742 4.5962 11.5931L4 12.1893V16H11.25V22H12.75V16H20V12.1893L19.4038 11.5931C18.1848 10.3742 17.5 8.72086 17.5 6.99695V2H6.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconThumbtack;
